import * as React from "react"

import {HOME_ROUTES, SHARE_OF_BROWSE_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"


export default function ShareOfSearchPage() {

    const props = {
        head: `DIP Insight | ${SHARE_OF_BROWSE_ROUTES.DETAILS_TITLE}`,
        title: SHARE_OF_BROWSE_ROUTES.DETAILS_TITLE,
        subtitle: SHARE_OF_BROWSE_ROUTES.DETAILS_SUBTITLE,
        isEmpty: false,
    }

    return <PageWrapper {...props}>
    {/*    USAD las tablas que hay en digital shelf para esto [SectionDetails] y adaptar loq ue haga falta*/}
    </PageWrapper>
}